import React, { useEffect, useState } from "react";
import SelectInput from "./selectInput";
import { viewSubAmenitiesList } from "../Redux/Actions/amenitiesActions";
import { useDispatch, useSelector } from "react-redux";

const AddProjectAmenities = ({
  amenities,
  onChange,
  disabled,
  defaultProjectType,
  selectedSubAmenityIds
}) => {
  const selectedSubAmenityIdsList = Array.isArray(selectedSubAmenityIds)
    ? selectedSubAmenityIds.map((a) => a._id)
    : [];
  const [addedAmenities, setAddedAmenities] = useState([]);
  const [addedAmenitiesName, setAddedAmenitiesName] = useState([]);

  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();

  const { subAmenities } = useSelector((state) => state.amenities || {});

  const amenityTrigger = () => {
    setModal(!modal);
  };

  const closeModal = () => {
    setModal(false);
  };

  const handleAmenitySelect = (id) => {
    const selectedAmenity = subAmenities?.data?.find((a) => a._id === id);
    if (!selectedAmenity) return;

    let updatedIds;
    let updatedNames;

    if (addedAmenities.includes(id)) {
      updatedIds = addedAmenities.filter((amenityId) => amenityId !== id);
      updatedNames = addedAmenitiesName.filter(
        (name) => name !== selectedAmenity.name
      );
    } else {
      updatedIds = [...addedAmenities, id];
      updatedNames = [...addedAmenitiesName, selectedAmenity.name];
    }

    setAddedAmenities(updatedIds);
    setAddedAmenitiesName(updatedNames);
    // onChange?.(
    //   updatedIds.map((id) => {
    //     const amenity = subAmenities?.data?.find((a) => a._id === id);
    //     return {
    //       _id: id,
    //       name: amenity?.name || "",
    //     };
    //   })
    // );
    onChange?.(
      updatedIds.map((id) => {
        const amenity = subAmenities?.data?.find((a) => a._id === id);
        return {
          _id: id,
          name: amenity?.name || "",
        };
      })
    );
  };

  const handleRemoveAmenity = (idToRemove) => {
    const updatedIds = addedAmenities.filter((id) => id !== idToRemove);
    const updatedNames = addedAmenitiesName.filter(
      (_, index) => addedAmenities[index] !== idToRemove
    );

    setAddedAmenities(updatedIds);
    setAddedAmenitiesName(updatedNames);

    onChange?.(
      updatedIds.map((id) => {
        const amenity = subAmenities?.data?.find((a) => a._id === id);
        return {
          _id: id,
          name: amenity?.name || "",
        };
      })
    );
  };

  useEffect(() => {
    if (Array.isArray(defaultProjectType)) {
      const ids = defaultProjectType.map((a) => a._id);
      const names = defaultProjectType.map((a) => a.name);
      setAddedAmenities(ids);
      setAddedAmenitiesName(names);
    }
  }, [defaultProjectType]);

  return (
    <div>
      <SelectInput
        label="Select Amenity"
        placeholder="Select an option"
        disabled={disabled}
        required
        onChange={(event) => {
          amenityTrigger();
          const selectedAmenity = event.target.value;
          const payload = {
            page: 1,
            limit: 2000,
            amenity_id: selectedAmenity,
          };
          dispatch(viewSubAmenitiesList(payload));
        }}
        options={
          Array.isArray(amenities)
            ? amenities.map((amenity) => ({
              label: amenity.name,
              value: amenity._id,
            }))
            : []
        }
      ></SelectInput>
      {/* <p className="margin-0">{addedAmenitiesName.join(", ")}</p> */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          margin: "10px 0",
        }}
        className="border-1-grey padding-5 border-15"
      >
        Added :{" "}
        {addedAmenities.map((id, index) => (
          <div
            key={id}
            className="padding-5 border-1-grey flex-container border-15"
          >
            <span>{addedAmenitiesName[index]}</span>
            <span
              onClick={() => handleRemoveAmenity(id)}
              className="margin-w-10"
              style={{
                cursor: "pointer",
                color: "red",
              }}
            >
              ❌
            </span>
          </div>
        ))}
      </div>
      {modal ? (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="list-style">
              {Array.isArray(subAmenities?.data)
                ? subAmenities.data.map((amenity, index) => (
                  <div
                    className={`amenity-card ${addedAmenities.includes(amenity._id) ||
                        selectedSubAmenityIdsList.includes(amenity._id)
                        ? "selected"
                        : ""
                      }`}
                    key={index}
                    onClick={() => handleAmenitySelect(amenity._id)}
                  >
                    <img src={amenity.image} alt={amenity.name} />
                    <p className="margin-0">{amenity.name}</p>
                  </div>
                ))
                : []}
            </div>
          </div>
        </div>
      ) : null}

    </div>
  );
};

export default AddProjectAmenities;
